import { useSearchAutocomplete } from 'view/hooks/useSearchAutocomplete';

export const useGetCompaniesForRecruiter = (search: string, page: number, limit: number = 20) => {
  return useSearchAutocomplete('/api/v1/companies/autocomplete', search, page, limit);
};
